import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { UserService } from '../../services/user.service';
import { Subject, ReplaySubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: true
})

export class HomePageComponent implements OnInit {
  title = 'FrameworkUI';
  protected homePage: string | any;

  constructor(private route: Router
    , protected userService: UserService
    , http: HttpClient
  ){}



  ngOnInit(): void {

    console.log("homePageComp");

    this.userService.getUserHomePage$()
      .subscribe(response => {
        this.homePage = response.userHomePage;
        //console.log(response);


        this.route.navigate([this.homePage]);
      });

  }

}
